import Box from '@paperstac/ui/lib/Box';
import Flex from '@paperstac/ui/lib/Flex';
import LinkButton from '@paperstac/ui/lib/LinkButton';
import React from 'react';
import ListingHeader from './ListingHeader';
import ListingNotes from './ListingNotes';
import ListingPrice from './ListingPrice';
import { MyListingsPageContext } from './MyListingsPageProvider';

const Listing = React.memo(({ listing }) => {
  const { setTransactionsToView } = React.useContext(MyListingsPageContext);
  const handleTransactions = React.useCallback(
    () => setTransactionsToView(listing.transactions),
    [listing.transactions, setTransactionsToView]
  );

  return (
    <>
      <ListingHeader
        listingId={listing.id}
        status={listing.status}
        url={listing.listingUrl}
        py={[2]}
        px={[3, 3, 3, 4]}
      />
      <Box
        sx={{
          border: 'default',
          borderTop: 'none',
          borderBottomLeftRadius: 'corner',
          borderBottomRightRadius: 'corner',
          p: [3, 3, 3, 4],
          bg: 'white',
          mb: 3,
        }}
      >
        <Flex
          sx={{
            flexDirection: ['column', 'column', 'column', 'row'],
            alignItems: ['flex-start', 'flex-start', 'flex-start', 'center'],
          }}
        >
          <Box
            sx={{
              flexGrow: [0, 0, 0, 1],
              mb: [3, 3, 3, 0],
            }}
          >
            <ListingNotes notes={listing.notes} />
          </Box>
          <Box
            sx={{
              flexBasis: ['auto', 'auto', 'auto', 250, 550],
              mb: [2, 2, 2, 0],
            }}
          >
            <ListingPrice listPrice={listing.listPrice} negotiationType={listing.negotiationType} />
          </Box>
          <Box
            sx={{
              flexBasis: ['auto', 'auto', 'auto', 170],
              textAlign: ['left', 'left', 'left', 'right'],
            }}
          >
            {listing.transactionCount === 0 && 'No Transactions'}
            {listing.transactionCount > 0 && (
              <LinkButton onClick={handleTransactions}>
                {listing.transactionCount} {listing.transactionCount === 1 ? 'Transaction' : 'Transactions'}
              </LinkButton>
            )}
          </Box>
        </Flex>
      </Box>
    </>
  );
});

Listing.propTypes = {};

Listing.defaultProps = {};

Listing.displayName = 'Listing';

export default Listing;
